import axios from 'axios'
import {BASE_URL} from '../../api'
import API_LINKS from '../../constant/api.links'

const useUser = () => {
  const getAnalytics = async () => {
    const url = BASE_URL + API_LINKS.GET_ANALYTICS
    try {
      const {data, status} = await axios.get(url)
      return {data, status}
    } catch (error: any) {
      throw new Error(error)
    }
  }
  const getUser = async (id: any) => {
    const url = BASE_URL + API_LINKS.GET_USERS + '/' + id

    const {data, status} = await axios.get(url)
    return {data, status}
  }

  const updatePremiumRequest = async (
    id: any,
    premium_request: any,
    duration: any,
    trialMonths?: number
  ) => {
    try {
      const url = BASE_URL + API_LINKS.UPDATE_PREMIUM_REQUEST
      const requestBody: any = {
        userId: id,
        premium_request,
        duration,
      }
      // Approve by granting a free trial (store bills automatically after).
      if (trialMonths) requestBody.trialMonths = trialMonths

      const {data, status} = await axios.put(url, requestBody)

      console.log(data, 'data')
      console.log(status, 'status')
      return {data, status}
    } catch (e: any) {
      console.log(e)
      throw new Error(e)
    }
  }

  const getUserSubscriptions = async (id: any) => {
    const url = BASE_URL + API_LINKS.GET_USER_SUBSCRIPTIONS + '/' + id
    try {
      const {data, status} = await axios.get(url)
      return {data, status}
    } catch (e: any) {
      console.log(e)
      throw new Error(e)
    }
  }

  const downloadUsersData = async () => {
    try {
      const url = BASE_URL + API_LINKS.DOWNLOAD_USERS
      const {data, status} = await axios.get(url)
      return {data, status}
    } catch (error: any) {
      throw new Error(error)
    }
  }
  // Grant (months) or withdraw (null) a free trial for a user.
  const setTrialOffer = async (id: any, months: number | null) => {
    const url = BASE_URL + API_LINKS.GET_USERS + '/' + id + '/trial-offer'
    const {data, status} = await axios.put(url, {months})
    return {data, status}
  }

  return {getUser, updatePremiumRequest, setTrialOffer, getUserSubscriptions, getAnalytics, downloadUsersData}
}

export default useUser
